import initSliders from "../components/initSliders.js";

document.addEventListener("DOMContentLoaded", () => {

    const {
        initGridSlider
    } = initSliders();

    initGridSlider();

});
